<template>
	<div>
   <div class="mheader" :class="{'dark':themeName=='dark'}" ><slot></slot><div class="rightcss"><router-link to="/search"><i class="iconfont icon-sousuo"></i></router-link></div></div>
</div></template>
<script>
	 
export default {
  name: 'Header',
}
</script>
